import type { Lot } from '../../types/lot'

/**
 * Resolve an incoming `?lotId=…` deep-link parameter against the lots
 * currently visible in the operator's chosen facility/PU scope on the
 * Costs screen.
 *
 * Returns the matching lot id when the URL points at a lot that is in
 * scope; returns `undefined` when the parameter is missing, empty, or
 * points at a lot that isn't in the current scope (e.g. wrong facility,
 * wrong PU, or an unknown id). The Costs screen calls this on mount and
 * whenever the scope changes; a non-match clears any previously seeded
 * lot rather than trapping the operator in a stale selection.
 *
 * v2.2 T3-C-07 (LCE-05). Kept as a pure helper so we can unit-test it
 * without pulling `useSearchParams` / router state into the screen test.
 */
export function resolveIncomingLotId(
  searchParams: URLSearchParams,
  scopedLots: readonly Pick<Lot, 'id'>[]
): string | undefined {
  const raw = searchParams.get('lotId')
  if (!raw) return undefined
  const trimmed = raw.trim()
  if (!trimmed) return undefined
  return scopedLots.some((lot) => lot.id === trimmed) ? trimmed : undefined
}
